import { createContext } from 'react'

const ContextData = createContext({modalData:{}})

export default ContextData